import React from 'react';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import { ICONS } from '../../../../../icons';
import Icon from '../../../../../icons/Icon';

import scss from '../SonarDatasetModal.module.scss';

const FieldWrapper = ({ children, label, isShowError, errorText }) => {
  return (
    <WithLabel label={label} variant={LABEL_STYLES.CUSTOM} isBold extraClassName={scss.generalSectionField}>
      <div className={scss.generalSectionFieldContent}>{children}</div>
      {isShowError ? (
        <div className={scss.generalSectionFieldError}>
          <Icon icon={ICONS.Info} disableCommonColors className={scss.errorIcon} />
          {errorText}
        </div>
      ) : null}
    </WithLabel>
  );
};

export default FieldWrapper;
